export default "__VITE_ASSET__DqqXLtHi__"